import React from 'react'
import { styled } from 'src/ui/theme'
import { Body } from 'src/ui/typography'
import { InnerList } from 'src/features/referral'
import {
  developersPolicy,
  adminEmployeesPolicy,
} from 'src/features/referral/utils'
import { HBox } from 'src/ui/layout'

const BlackLink = styled.a`
  color: ${({ theme }) => theme.colors.black.bg};
`

const StyledParagraph = styled.li`
  color: ${({ theme }) => theme.colors.black.bg};
  margin-bottom: 24px;
  list-style: inside decimal;

  &:last-child() {
    margin-bottom: 0;
  }
`

const InnerListWrap = styled.div`
  padding-left: 5px;
  display: flex;
  flex-direction: column;
`

const InnerListTitle = styled(Body)`
  padding-left: 15px;
  color: ${({ theme }) => theme.colors.black.bg};
  font-weight: 400;
`

export const ReferralPolicyList = () => {
  return (
    <ol>
      <StyledParagraph>
        Участниками реферальной программы могут стать пользователи, достигшие 18
        лет, имеющие кредитную/дебетовую карту одного из банков в вашей стране
        проживания. Участниками программы могут стать жители любых стран,
        городов и населённых пунктов.
      </StyledParagraph>
      <StyledParagraph>
        Вознаграждения за успешную рекомендацию:
      </StyledParagraph>
      <InnerListWrap>
        <InnerListTitle>
          2.1. Производство (разработчики, аналитики, дизайнеры, PM)
        </InnerListTitle>
        <InnerList items={developersPolicy} />
        <HBox height={24} />
        <InnerListTitle>2.2. Администрация (рекрутеры, HR)</InnerListTitle>
        <InnerList items={adminEmployeesPolicy} />
        <HBox height={24} />
      </InnerListWrap>
      <StyledParagraph>
        Актуальная информация об открытых вакансиях представлена на нашем сайте{' '}
        <BlackLink href="https://career.kode.ru/career/">
          https://career.kode.ru/career/.
        </BlackLink>
      </StyledParagraph>
      <StyledParagraph>
        Для участия в реферальной программе необходимо перейти на сайт
        реферальной программы от KODE{' '}
        <BlackLink href="https://career.kode.ru/referral">
          https://career.kode.ru/referral
        </BlackLink>
        , затем нажать на кнопку «Рекомендовать друга» и заполнить форму
        рекомендации.
      </StyledParagraph>
      <StyledParagraph>
        Отправляя персональные данные, а именно: имя и фамилию, контактный номер
        телефона, email, — вы автоматически соглашаетесь с обработкой
        персональных данных, согласно законодательству «О защите персональных
        данных» в стране вашего проживания. (В каждой стране трактовка пунктов
        законодательства «О защите персональных данных» может отличаться).
      </StyledParagraph>
      <StyledParagraph>
        Ваши персональные данные, а также персональные данные рекомендуемого
        вами участника, собираются компанией KODE исключительно для участия в
        реферальной программе, а также уведомлений и сообщений, которые позволят
        участникам оставаться в курсе последних новостей реферальной программы.
      </StyledParagraph>
      <StyledParagraph>
        Перед отправкой персональных данных рекомендуемого вами кандидата
        необходимо получить устное или письменное согласие от кандидата на
        обработку его персональных данных для участия в реферальной программе.
      </StyledParagraph>
      <StyledParagraph>
        Претендовать на вакансии, участвующие в реферальной программе, могут
        только кандидаты, ранее не сотрудничавшие с KODE.
      </StyledParagraph>
      <StyledParagraph>
        Анкета кандидата должна быть заполнена согласно пунктам, указанным в
        форме для заполнения. Неверно указанная информация в конкретных полях
        формы может усложнить обработку информации, и данная информация не будет
        приниматься от участников реферальной программы.
      </StyledParagraph>
      <StyledParagraph>
        Если у участника реферальной программы после отправки рекомендации
        изменились реквизиты для выплаты вознаграждения, и он не сообщил об этом
        рекрутеру реферальной программы до трудоустройства кандидата, то
        вознаграждение не выплачивается.
      </StyledParagraph>
      <StyledParagraph>
        Понятие «Успешная рекомендация» применяется к кандидатам, которые прошли
        собеседование, завершили испытательный срок в компании (3 месяца) и
        продолжили сотрудничество с KODE.
      </StyledParagraph>
      <StyledParagraph>
        Рекомендации на кандидата, которые были предоставлены для обработки
        отделу рекрутинга иными или дополнительными способами (посредством
        личного email-сообщения, устного обращения с рекомендацией к
        представителю отдела рекрутинга, персонального сообщения в социальных
        сетях и мессенджерах), не относящимися к заполнению конкретной Google
        формы, участие в данной реферальной программе не принимают.
      </StyledParagraph>
      <StyledParagraph>
        По дополнительным вопросам, связанным с участием в реферальной
        программе, вы можете обращаться на email:&nbsp;
        <BlackLink href="mailto:recruting@kode.ru">recruting@kode.ru</BlackLink>
      </StyledParagraph>
    </ol>
  )
}
